import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";

import type { Corrugate } from "@/schemas";

export interface ZFoldCheckboxListProps {
	readonly corrugates: Corrugate[];
	readonly selectedIds: string[];
	readonly onChange: (selectedIds: string[]) => void;
}

export const ZFoldSelectionList: React.FC<ZFoldCheckboxListProps> = ({ corrugates, selectedIds, onChange }) => {
	return (
		<Box sx={{ overflow: "auto", minHeight: 0, flex: 1 }}>
			<FormGroup>
				{corrugates.map((corrugate) => (
					<FormControlLabel
						key={corrugate.id}
						control={
							<Checkbox
								checked={selectedIds.includes(corrugate.id)}
								onChange={(_, checked) => {
									if (checked) {
										onChange([...selectedIds, corrugate.id]);
										return;
									}

									onChange(selectedIds.filter((id) => id !== corrugate.id));
								}}
								data-testid={`production-groups-configuration-modal__checkbox__corrugate-${corrugate.id}`}
								data-pendoid={`production-groups-configuration-modal__checkbox__corrugate-${corrugate.alias?.toLowerCase()?.replace(/\s+/g, "-")}`}
							/>
						}
						label={
							corrugate.alias || (
								<Typography component="span" fontStyle="italic" color="text.disabled">
									<FormattedMessage id="Unnamed z-Fold" defaultMessage="Unnamed z-Fold" />
								</Typography>
							)
						}
					/>
				))}
			</FormGroup>
		</Box>
	);
};
